<template>
    <resource-index title="Филиалы" endpoint="admin/branches">
        <template slot="header-buttons">
            <router-link
                class="btn btn-secondary"
                :to="{
                    name: 'admin.branches.create',
                }">Создать</router-link>
        </template>

        <template v-slot:table-header>
            <tr class="border-b">
                <th class="text-left p-3 px-5" scope="col">Название</th>
                <th class="text-left p-3 px-5" scope="col">Адрес</th>
                <th class="text-left p-3 px-5" scope="col"></th>
            </tr>
        </template>

        <template v-slot:table-filters="slotProps">
            <tr class="border-b bg-gray-100">
                <th class="p-3 px-5" scope="col">
                    <text-field :wrap="false" v-model="slotProps.filters.name" />
                </th>

                <th class="p-3 px-5" scope="col">
                    <text-field :wrap="false" v-model="slotProps.filters.address" />
                </th>

                <th class="p-3 px-5" scope="col"></th>
            </tr>
        </template>

        <template v-slot:row="slotProps">
            <td class="p-3 px-5">
                {{ slotProps.entry.name }}
            </td>

            <td class="p-3 px-5">
                {{ slotProps.entry.address }}
            </td>

            <td class="p-3 px-5">
                <router-link
                    :to="{
                        name: 'admin.branches.edit',
                        params: {
                            id: slotProps.entry.id
                        }
                    }"
                    class="btn btn-info">Изменить</router-link>
            </td>
        </template>
    </resource-index>
</template>

<script>
    import ResourceIndex from '@/components/Resource/ResourceIndex';
    
    export default {
        components: {
            ResourceIndex,
        },
    }
</script>